import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

/**
 * Reads a row from public.feature_flags.
 *
 * Flags are keyed `<area>.<thing>.enabled` (the convention notify_admins() uses,
 * e.g. `notifications.admin_alerts.enabled`). The table has a SELECT policy for
 * authenticated users, so the browser can read it directly.
 *
 * FAILS CLOSED: a missing row, an RLS denial or a network error all resolve to
 * `false`, matching the server-side helper. A flag that cannot be read must never
 * be treated as enabled — the UI copy that depends on this promises a trade when
 * their money moves.
 */
export function useFeatureFlag(flagKey: string) {
    const query = useQuery({
        queryKey: ['feature-flag', flagKey],
        queryFn: async () => {
            const { data, error } = await supabase
                .from('feature_flags')
                .select('is_enabled')
                .eq('flag_key', flagKey)
                .maybeSingle();

            if (error) {
                console.warn(`[useFeatureFlag] Failed to read ${flagKey}:`, error.message);
                return false;
            }
            return data?.is_enabled === true;
        },
        staleTime: 5 * 60 * 1000,
    });

    return {
        isEnabled: query.data === true,
        isLoading: query.isLoading,
    };
}

/** Whether the 7-day variation auto-release cron is active. */
export const VARIATION_AUTO_RELEASE_FLAG = 'payouts.variation_auto_release.enabled';
